/**
 * Adresses du centre d'aide (sans contenu : importable partout sans charger les articles).
 * - aide de l'équipe : `/aide` et `/aide/<article>`, publique (rien de propre à un garage) ;
 * - aide du client : `/aide/client` et `/aide/client/<article>`, publique, sans marque de garage.
 * Aucune donnée personnelle, aucun jeton dans ces adresses.
 */
export type HelpAudience = 'team' | 'client';

export const HELP_HOME: Record<HelpAudience, string> = { team: '/aide', client: '/aide/client' };

export function helpArticlePath(audience: HelpAudience, slug: string): string {
  return `${HELP_HOME[audience]}/${slug}`;
}

/** Articles de l'équipe visés par les liens « ? » des écrans (vérifiés par les tests). */
export type TeamHelpSlug =
  | 'accueil-ma-journee'
  | 'a-l-atelier'
  | 'rendez-vous-agenda'
  | 'entree-vehicule'
  | 'dossier'
  | 'messagerie'
  | 'base-garage'
  | 'gestion'
  | 'compte-marque'
  | 'compte-equipe-roles'
  | 'compte-modules'
  | 'compte-notifications'
  | 'emails-envoyes'
  | 'import-csv'
  | 'horaires'
  | 'catalogue';
